export const images = {
  hero: [
    'https://images.unsplash.com/photo-1755757573547-294f87d1c16b?w=1920&q=80',
    'https://images.unsplash.com/photo-1617184003107-0df15fea4903?w=1920&q=80', // Holi celebration
    'https://images.unsplash.com/photo-1707938292313-2e4b3eabc5a4?w=1920&q=80',
    'https://images.unsplash.com/photo-1690271649975-f333ae373d8d?w=1920&q=80',
  ],
  rooms: [
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/fw4oa3wq_2022-09-27.webp',
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/kzl5asdf_unnamed.webp',
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/oaompon8_2022-09-27%20%281%29.webp',
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/aw7wkvb7_unnamed.jpg',
  ],
  facilities: [
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/9pqnsy5u_IMG_20220723_090657.jpg',
    'https://customer-assets.emergentagent.com/job_vrindavan-nest/artifacts/ls7yoq1c_unnamed%20%281%29.jpg',
  ],
  vrindavanAttractions: [
    {
      url: 'https://images.unsplash.com/photo-1697528556914-5b2e767bbb5f?w=800&q=80',
      name: { en: 'Madan Mohan Temple', bn: 'মদন মোহন মন্দির' },
      description: { en: 'Oldest temple in Vrindavan', bn: 'বৃন্দাবনের প্রাচীনতম মন্দির' }
    },
    {
      url: 'https://images.unsplash.com/photo-1593662557880-17e49ff8c6c9?w=800&q=80',
      name: { en: 'ISKCON Temple', bn: 'ইসকন মন্দির' },
      description: { en: 'Magnificent Krishna temple', bn: 'দুর্দান্ত কৃষ্ণ মন্দির' }
    },
    {
      url: 'https://images.unsplash.com/photo-1718169538846-6c4e3a2c1fe3?w=800&q=80',
      name: { en: 'Rangnath Ji Temple', bn: 'রঙ্গনাথ জি মন্দির' },
      description: { en: 'Beautiful white architecture', bn: 'সুন্দর সাদা স্থাপত্য' }
    },
    {
      url: 'https://images.pexels.com/photos/24862859/pexels-photo-24862859.jpeg?w=800&q=80',
      name: { en: 'Banke Bihari Temple', bn: 'বাঁকে বিহারী মন্দির' },
      description: { en: 'Most famous temple', bn: 'সবচেয়ে বিখ্যাত মন্দির' }
    },
    {
      url: 'https://images.unsplash.com/photo-1617184003107-0df15fea4903?w=800&q=80',
      name: { en: 'Holi Festival', bn: 'হোলি উৎসব' },
      description: { en: 'Experience colors of joy', bn: 'আনন্দের রং অনুভব করুন' }
    },
    {
      url: 'https://images.unsplash.com/photo-1676574834058-1d5717a3c04a?w=800&q=80',
      name: { en: 'Evening Aarti', bn: 'সন্ধ্যা আরতি' },
      description: { en: 'Spiritual evening prayers', bn: 'আধ্যাত্মিক সন্ধ্যা প্রার্থনা' }
    }
  ],
  ambiance: [
    'https://images.unsplash.com/photo-1671512226229-e05294dd1970?w=800&q=80',
    'https://images.unsplash.com/photo-1676574834058-1d5717a3c04a?w=800&q=80',
    'https://images.pexels.com/photos/30854162/pexels-photo-30854162.jpeg?w=800&q=80',
  ]
};

export const temples = [
  { name: { en: 'Radha Raman Ji', bn: 'রাধা রমণ জি' }, distance: '0.5 km' },
  { name: { en: 'Gopinath Ji', bn: 'গোপীনাথ জি' }, distance: '0.3 km' },
  { name: { en: 'Nidhiwan', bn: 'নিধিবন' }, distance: '0.4 km' },
  { name: { en: 'Govind Dev Ji', bn: 'গোবিন্দ দেব জি' }, distance: '0.8 km' },
  { name: { en: 'Rangnath Ji', bn: 'রঙ্গনাথ জি' }, distance: '0.9 km' },
  { name: { en: 'Banke Bihari', bn: 'বাঁকে বিহারী' }, distance: '1.2 km' },
  { name: { en: 'Radha Vallabh Ji', bn: 'রাধা বল্লভ জি' }, distance: '0.6 km' },
  { name: { en: 'Seva Kunj', bn: 'সেবা কুঞ্জ' }, distance: '0.7 km' },
  { name: { en: 'Keli Kunj', bn: 'কেলি কুঞ্জ' }, distance: '0.7 km' },
  { name: { en: 'Gopeshwar Mahadev', bn: 'গোপেশ্বর মহাদেব' }, distance: '1.0 km' },
  { name: { en: 'Vanshivat', bn: 'বংশীবট' }, distance: '1.1 km' },
  { name: { en: 'Kesi Ghat', bn: 'কেশী ঘাট' }, distance: '1.5 km' },
  { name: { en: 'Radha Damodar Ji', bn: 'রাধা দামোদর জি' }, distance: '0.5 km' },
];

export const contactInfo = {
  phone: '9460258296',
  email: 'shailu0287@gmail.com',
  address: {
    en: '98, Cinema Hall Gali, Gopinath Bajar, Near Bharti Mithai Wala, Vrindavan, Mathura - 281121',
    bn: '৯৮, সিনেমা হল গলি, গোপীনাথ বাজার, ভারতী মিঠাই ওয়ালার কাছে, বৃন্দাবন, মথুরা - ২৮১১২১'
  },
  googleProfile: 'https://share.google/Pa1S5iKSDnusvwYLJ',
  mapUrl: 'https://maps.google.com/?q=Nidhiwan+Homestay+Vrindavan'
};
